module.exports = __webpack_public_path__ + "static/media/amazon-pay.1ceace20.svg";